module.exports = __webpack_public_path__ + "static/richard-kathleen-lo-555f08532ffdf23f44ebdcfbaef673f2.jpg";